import { type ReactNode } from 'react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
} from '@/components/StickyViewHeader'
import styles from './FirmDashboard.module.css'
import { useScrollOffsets } from '@/hooks/element-hooks'

export interface FirmDashboardProps {
  heading: ReactNode
  overviewSidebar: ReactNode
  quickSelectFilter: ReactNode
  jobCount: ReactNode
  jobsViewerHeader: ReactNode
  jobsViewer: ReactNode
}

export function FirmDashboard({
  heading,
  overviewSidebar,
  quickSelectFilter,
  jobCount,
  jobsViewerHeader,
  jobsViewer,
}: FirmDashboardProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <div ref={scrollRef} className={styles.root}>
      <StickyViewHeader scrollOffset={scrollOffset}>
        <StickyViewHeaderMain>{heading}</StickyViewHeaderMain>
        <StickyViewHeaderSpacer />
      </StickyViewHeader>

      <div className={styles.container}>
        <div className={styles.overviewSidebarContainer}>{overviewSidebar}</div>

        <div className={styles.mainContent}>
          <div className={styles.quickSelectFilterContainer}>
            {quickSelectFilter}
          </div>

          {jobCount}

          <div className={styles.jobsTableHeader}>{jobsViewerHeader}</div>

          <div className={styles.jobsTable}>{jobsViewer}</div>
        </div>
      </div>
    </div>
  )
}
